import React from "react";
import { HelpCircle } from "lucide-react";

export function PricingFAQ() {
  return (
    <div className="max-w-3xl mx-auto mt-24">
      <h2 className="text-2xl font-bold text-white text-center mb-12">
        Frequently Asked Questions
      </h2>

      <div className="space-y-8">
        <div className="bg-white/5 rounded-xl p-6">
          <div className="flex items-start">
            <HelpCircle className="h-6 w-6 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-medium text-white mb-2">
                What happens when I reach my monthly request limit?
              </h3>
              <p className="text-gray-400">
                When you reach your monthly request limit, you'll be notified
                and given the option to upgrade to a higher plan or wait until
                your limit resets at the beginning of your next billing cycle.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white/5 rounded-xl p-6">
          <div className="flex items-start">
            <HelpCircle className="h-6 w-6 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-medium text-white mb-2">
                Can I cancel my subscription at any time?
              </h3>
              <p className="text-gray-400">
                Yes, you can cancel your subscription at any time. Your access
                will continue until the end of your current billing period, and
                you won't be charged again.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white/5 rounded-xl p-6">
          <div className="flex items-start">
            <HelpCircle className="h-6 w-6 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-medium text-white mb-2">
                Do you offer refunds?
              </h3>
              <p className="text-gray-400">
                We offer a 14-day money-back guarantee for all new
                subscriptions. If you're not satisfied with our service, contact
                our support team within 14 days of your purchase for a full
                refund.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white/5 rounded-xl p-6">
          <div className="flex items-start">
            <HelpCircle className="h-6 w-6 text-volt-blue mr-3 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-medium text-white mb-2">
                Can I use the generated patterns on client websites?
              </h3>
              <p className="text-gray-400">
                Yes, all patterns generated with our tool can be used on both
                personal and client websites without any additional licensing
                fees. There are no restrictions on commercial usage.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
